import Vue from 'vue';
import Component from 'vue-class-component';
import getLastTld from 'common/services/getLastTld';

import ProductBlock from 'common/components/ProductBlock';
import Rating from 'common/components/Rating';

@Component({
  components: {
    ProductBlock,
    Rating,
    OfferLabel: () => import('components/OfferLabel/OfferLabel.vue'),
  },
  props: {
    box: {
      type: Object,
      required: true,
    },
    bigBlock: {
      type: Boolean,
      default: false,
      description:
        'Change styles of the Block. True if 3 blocks will be displayed in a row',
    },
    campaignSlug: {
      type: String,
      required: false,
    },
    landingSlug: {
      type: String,
      required: false,
    },
  },
})
export default class NewBoxBlockComponent extends Vue {
  offerLabelTitle = '';
  offerLabelDescription = '';

  mounted() {
    this.offerLabelTitle = this.getOfferLabelTitle();
    this.offerLabelDescription = this.getOfferLabelDescription();
  }

  getOfferLabelTitle() {
    return `Contiene ${this.plural(
      this.box.box_activities_in_box,
      'experiencia',
      true,
    )} que`;
  }

  getOfferLabelDescription() {
    return `${this.plural(this.box.box_activities_in_box, [
      'coincide',
      'coinciden',
    ])} con tu búsqueda`;
  }

  get tld() {
    return getLastTld(window.location.hostname);
  }

  get boxClicked() {
    let newRoute;
    if (this.box.product_url) {
      newRoute = { path: this.box.product_url };
    } else {
      newRoute = {
        name: 'box',
        params: {
          categorySlug: this.category.slug,
          boxSlug: this.box.slug,
        },
      };
    }
    if (this.campaignSlug) {
      newRoute.query = {
        ...newRoute.query,
        campaignSlug: this.campaignSlug,
      };
    }
    if (this.landingSlug) {
      newRoute.query = {
        ...newRoute.query,
        landingSlug: this.landingSlug,
      };
    }

    return newRoute;
  }

  get feePrice() {
    return this.box.price / this.box.installments;
  }

  get feePriceInt() {
    return Math.floor(this.feePrice);
  }

  get feePriceDecimal() {
    const theDecimal = this.feePrice - this.feePriceInt;
    if (theDecimal) {
      return theDecimal.toFixed(2) * 100;
    }
    return '';
  }

  get totalActivitiesInBox() {
    return this.box.activities ? this.box.activities.length : '';
  }

  get showSearchResults() {
    return Boolean(this.$route.query.keywords);
  }

  get selectedPrice() {
    let price = this.box.use_price_in_usd
      ? this.box.price_in_usd
      : this.box.price;
    return this.currency(price, 0, this.box.use_price_in_usd);
  }
}
